jQuery(document).ready(function ($) {
    const single_galleries = $('.single__gallery');

    single_galleries.each(function () {
        const single_gallery = new Swiper(`#${$(this).attr('id')}`, {
            loop: true,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            spaceBetween: 24,

            pagination: {
                el: '.single__gallery--pagination',
                type: 'bullets',
                bulletClass: 'pagination__bullet',
                bulletActiveClass: 'active',
                clickable: true
            },

            autoplay: true,
            delay: 8000,

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                }
            }
        });
    });
});